import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { LogService } from '../services/log/log.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class LogInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {

    // Production mode - don't log anything, just pass through
    if (environment.production) {
      return next.handle(request);
    }
    // Development mode - log requests and responses

    const url = request.urlWithParams;
    const method = request.method;

    LogService.logInfo(`Request to ${method} ${url}`);
    if (request.body) {
      LogService.logDebug('Request Body:', request.body);
    }
    if (request.params.keys().length > 0) {
      LogService.logDebug(
        'Query Parameters:',
        request.params.keys().map((key) => `${key}: ${request.params.get(key)}`)
      );
    }

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            // Log successful response
            LogService.logInfo(`Response from ${url}: ${event.status}`);
            LogService.logDebug('Response Body:', event.body);
          }
        },
        error: (error) => {
          // Log any errors
          LogService.logError(`Error from ${url}`, error);
        },
      })
    );
  }
}
